// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { useState, useRef, useEffect, useCallback } from 'react';

import { Button } from '../../../../web-utils/src/UI/Component/React/V1/Button/Button';
import { Icons } from '../../../../web-utils/src/UI/Component/React/V1/Icons/Icons';

import styles from './PopOver.module.css';
import button from '../Button/Button.module.css';

export const PopOver = ({
  buttonText,
  downIcon = true,
  position = 'bottom',
  useDefaultButtonStyle = false,
  width,
  children,
  ...props
}) => {
  const { color, classname, hoverEffect } = props;
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = useCallback(event => {
    const el = ref.current;

    if (!el) {
      return;
    }

    if (!el.contains(event.target)) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, true);

    return () => document.removeEventListener('mousedown', handleClickOutside, true);
  }, [handleClickOutside]);

  const buttonClass = `
    ${classname || ''}
    ${isOpen && hoverEffect ? styles.active : ''}
    ${useDefaultButtonStyle ? button.moButton : ''}
  `.trim();

  return (
    <div className={styles.container} ref={ref}>
      <div className={styles.button}>
        <Button color={color} onClick={() => setIsOpen(!isOpen)} classname={buttonClass}>
          <span className={styles.wrapper}>
            <Icons {...props} />
            {buttonText && buttonText}
          </span>
          {downIcon && <Icons iconType='down' iconSize={12} />}
        </Button>
      </div>

      {isOpen && (
        <div className={`${styles.content} ${styles[position]}`} style={{ width }}>
          {typeof children === 'function' ? children({ setIsOpen }) : children}
        </div>
      )}
    </div>
  );
};
